import { TimelineSection } from '../section-listing.model';

export class ProgressSection extends TimelineSection {
  currentProgress: string;
  progressComments: string;
}
